/**
 * Extension registry — import and list extension components here.
 * Home.jsx renders them below the hero section.
 * An empty array means no extensions; the portal works normally.
 */
import AiBridgeWidget from './AiBridgeWidget';

const extensions = [
  AiBridgeWidget,
];

export default extensions;
